
define('text!modules/reporting/segments/dataExport/manage/templates/grid.html',[],function () { return '<div class="somegridstuff"></div>';});

